module.exports = __webpack_public_path__ + "static/media/ic_camera_switch_white.619ba467.svg";